<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Returns</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col-8">
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of adminReturnMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus);"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
        </ng-container>
        <li class="list-inline-item">
          <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
          <div class="dropdown-menu dropdown-menu2">
            <ng-container *ngFor="let om of adminReturnMainMenu">
              <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                 (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
            </ng-container>
          </div>
        </li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
        <option *ngFor="let u of adminReturnMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
      </select>
    </div>
    <div class="col mt-md-0 btn-sm text-right float-right">
      <div class="d-inline">
        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn ml-2 btn-outline-primary dropdown-toggle d-none-mobile"
                *ngIf="(checkedList?.length) && tabClicked !== 'all'">
          Actions
        </button>
        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right ml-3"
             *ngIf="(checkedList?.length) && tabClicked !== 'all'">
          <a *ngIf="tabClicked === 'submitted'" (click)="selectCarrier(orders)"
             class="dropdown-item file btn shift-import">Select the Carrier</a>
          <a *ngIf="tabClicked === 'submitted'" (click)="cancelMultiReturnOrders(orders)"
             class="dropdown-item file btn shift-import">Cancel the Return Request</a>
          <a *ngIf="tabClicked === 'requestForPickUp'" (click)="returnOrderInTransit(orders)"
             class="dropdown-item file btn shift-import">Move To In-transit</a>
          <a *ngIf="tabClicked === 'requestForPickUp'" (click)="cancelMultiReturnOrders(orders)"
             class="dropdown-item file btn shift-import">Cancel the Return Request</a>
          <a *ngIf="tabClicked === 'inTransit'" (click)="assignedPick(orders)"
             class="dropdown-item file btn shift-import">Receive Order</a>
          <a *ngIf="tabClicked === 'received'" (click)="returnOrderCompleted(orders)"
             class="dropdown-item file btn shift-import">Move to Completed</a>
        </div>
      </div>
      <div class="d-inline">
        <a placement="bottom" ngbTooltip="Create" class="mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createReturnManually" width="30" height="30"
               viewBox="0 0 30 30">
            <defs>
              <style>.a {
                fill: #8a55bb;
              }

              .b {
                fill: #fff;
              }</style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                    transform="translate(2.823 3.938)"/>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th [hidden]="tabClicked ==='all'">
            </th>
            <th>Order#</th>
            <th>Order Date</th>
            <th>Source Order Num</th>
            <th>Owner Name</th>
            <th>Reason</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td [hidden]="tabClicked ==='all'">
              <div class="form-checkbox">
                <input type="checkbox" id="{{o.orderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                       (change)="selectShip(o)">
                <label for="{{o.orderHeaderId}}"></label></div>
            </td>
            <td style="text-transform:capitalize;"><a
              routerLink="/admin/viewReturnOrder/{{o.orderNumber}}">{{o.orderNumber}}</a>
            </td>
            <td>{{o.orderedDate}}</td>
            <td>{{o.sourceOrderNum}}</td>
            <td>{{o.ownerName | titlecase}}</td>
            <td>{{o.returnReason}}</td>
            <td>{{(o.orderStatus == 'SUBMITTED' ? 'Submitted' : (o.orderStatus == 'RETURN' ? 'Return' : (o.orderStatus ==
            'PROCESSING' ? 'Processing' : (o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' : (o.orderStatus
            == 'SHIPPED' ? 'Shipped' :
              (o.orderStatus == 'RTO' ? 'RTO' :
              (o.orderStatus == 'CANCELLED' ? 'Cancelled' :
              (o.orderStatus == 'EXCEPTION' ? 'Exception' :
              (o.orderStatus == 'TO_PICK' ? 'Ready to Pick' :
              (o.orderStatus == 'PICK_ASSIGNED' ? 'Picker Assigned' :
               (o.orderStatus == 'TO_PACK' ? 'To Pack' :
                 (o.orderStatus == 'GENERATED' ? 'Generated' :
                  (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                   (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                    (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                     (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' :
                      (o.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned' :
                       (o.orderStatus == 'DELIVERED' ? 'Delivered' :
                        (o.orderStatus == 'ON_HOLD' ? 'On Hold' :
                          (o.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted' : o.orderStatus))))))))))))))))))))
              |titlecase}}
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td colspan="7" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order#</th>
            <th>Order Date</th>
            <th>Warehouse Name</th>
            <th>Contact Name</th>
            <th>Ship Date</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td><b class="tablesaw-cell-label">Order#</b>
              <span class="tablesaw-cell-content"><a
                routerLink="/admin/viewReturnOrder/{{o.returnOrderHeaderId}}">{{o.orderNumber}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Order Date</b>
              <span class="tablesaw-cell-content">{{o.orderedDate}}</span></td>
            <td><b class=" tablesaw-cell-label">Warehouse Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.warehouseName}}</span></td>
            <td><b class=" tablesaw-cell-label">Contact Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.contactName}}</span></td>
            <td><b class=" tablesaw-cell-label">Ship Date</b>
              <span class="tablesaw-cell-content">{{o.shippedDate}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span
                class="tablesaw-cell-content">{{(o.orderStatus == 'SUBMITTED' ? 'Submitted' : (o.orderStatus == 'RETURN' ? 'Return' : (o.orderStatus == 'PROCESSING' ? 'Processing' : (o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' : (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                (o.orderStatus == 'COMPLETED' ? 'Completed' : (o.orderStatus == 'CANCELLED' ? 'Cancelled' : (o.orderStatus == 'EXCEPTION' ? 'Exception' : (o.orderStatus == 'TO_PICK' ? 'Ready to Pick' : (o.orderStatus == 'PICK_ASSIGNED'
                  ? 'Picker Assigned' : (o.orderStatus == 'TO_PACK' ? 'To Pack' : (o.orderStatus == 'GENERATED' ? 'Generated' : (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' : (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' : (o.orderStatus
                  == 'GENERATE_LABEL' ? 'Generate Label' : (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : (o.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned' : (o.orderStatus == 'DELIVERED' ? 'Delivered' : (o.orderStatus == 'ON_HOLD'
                    ? 'On Hold' : (o.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted' : o.orderStatus)))))))))))))))))))) |titlecase}}
              </span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div [ngStyle]="{'display': otpPopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': otpPopUp == 'Y'}" class="modal" id="otpPopUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="deliverExampleModalPreviewLabel">OTP to Submit Delivery</h5>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <form>
                <div class="invalid-feedback d-block mb-3" [hidden]="!errorMessage">{{errorMessage}}</div>
                <p class="mt-5">
                  Enter 4 digit pin sent to Customer Mobile</p>
                <div class="row">
                  <div class="col-2"><input type="text" (keyup)="keytab($event, 'password2', 'password1')"
                                            id="password1" [(ngModel)]="password1" class="form-control text-center"
                                            maxlength="1" [ngModelOptions]="{standalone: true}" required></div>
                  <div class="col-2"><input type="text" (keyup)="keytab($event, 'password3', 'password1')"
                                            id="password2" [(ngModel)]="password2" class="form-control text-center"
                                            maxlength="1" [ngModelOptions]="{standalone: true}" required></div>
                  <div class="col-2"><input type="text" (keyup)="keytab($event, 'password4', 'password2')"
                                            id="password3" [(ngModel)]="password3" class="form-control text-center"
                                            maxlength="1" [ngModelOptions]="{standalone: true}" required></div>
                  <div class="col-2"><input type="text" (keyup)="keytab($event, 'password4', 'password3')"
                                            id="password4" [(ngModel)]="password4" class="form-control text-center"
                                            maxlength="1" [ngModelOptions]="{standalone: true}" required></div>
                </div>
                <div class="row align-items-center mb-4 mt-4">
                  <div class="col-md-12 text-center">
                    <a (click)="submitResend()">Resend OTP</a>
                  </div>
                </div>
              </form>
              <div class="row mt-2">
                <div class="col-md-12 text-right">
                  <button class="btn btn-cancel" type="button" (click)="closePopUp()" aria-label="Close">Clear</button>
                  <button type="submit" class="btn btn-orange ml-1" (click)="otpSubmit()">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
